import React from 'react'

interface IProps {
  className?: string
  activator: (handler: () => void) => React.ReactElement
  onChange?: (file: File) => void
}
function Upload(props: IProps): React.ReactElement {
  const inputRef = React.useRef<HTMLInputElement>(null)

  const handleClick = (): void => {
    inputRef.current?.click()
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0]

    if (file) {
      props.onChange?.(file)
    }
  }

  return (
    <div className={`upload ${props.className ?? ''}`.trim()}>
      {props.activator(handleClick)}
      <input
        type="file"
        onChange={handleChange}
        ref={inputRef}
        style={{ display: 'none' }}
      />
    </div>
  )
}

export default Upload
